import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ToastService } from '../../services/toast-service/toast.service';
import { ActivatedRoute} from '@angular/router';
import { COGNITO_ACTION_TYPE, COGNITO_MESSAGES } from 'src/assets/constants/globalContants';
import { LoaderService } from '../../services/loader/loader.service';
import { UserFormCognitoService } from '../../services/user-form-cognito/user-form-cognito.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-usercogform',
    templateUrl: './usercogform.component.html',
    styleUrls: ['./usercogform.component.scss'],
    standalone: false
})
export class UsercogformComponent implements OnInit{
  loading: boolean = false;
  overlayState: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  isTokenValid: boolean = false;
  @ViewChild('successTpl', { static: false }) successTpl!: TemplateRef<any>;
  @ViewChild('dangerTpl', { static: false }) dangerTpl!: TemplateRef<any>;
  cogFormId: number | null = null;
  formData: any = {};
  requestResponse: any;

  constructor(private readonly route: ActivatedRoute, private readonly toastService: ToastService, public loaderService: LoaderService, private readonly userFormService: UserFormCognitoService) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let token = params['token'] ? decodeURIComponent(params['token']) : null;
      const actionType = params['actionType'];
      const formId = params['cogFormId'] ?? environment.openUser;
      if (token) {
        // replace the space with + sign in token
        token = token.replace(/ /g, '+');
      }
      if (token && actionType === COGNITO_ACTION_TYPE.COG_FORM && formId) {
        this.loading = true;
        this.overlayState = true;
        this.verifyTokenValidity(token, formId);
      } else {
        this.showMessage(COGNITO_MESSAGES.NO_TOKEN, false);
      }
    });
  }

  /**
   * showMessage - Displays a message to the user.
   * @param message - The message to display.
   * @param isSuccess - Whether the message is a success message or an error message.
   */
  private showMessage(message: string, isSuccess: boolean) {
    if (isSuccess) {
      this.successMessage = message;
      this.errorMessage = '';
    } else {
      this.errorMessage = message;
      this.successMessage = '';
    }

    setTimeout(() => {
      this.successMessage = '';
      this.errorMessage = '';
    }, 5000);
  }

  /**
   * showSuccess() - Displays a success toast notification with custom content and options.
   * @param successTpl - The template reference containing the toast's content.
   */
  showSuccess(successTpl: TemplateRef<any>) {
    this.toastService.clear();
    this.toastService.show(successTpl, {
      classname: 'custom-toast',
      delay: 6000,
    });
  }

  /**
   * showDanger() - Displays a danger (error) toast message.
   * This method is called when there is an error in adding the user.
   * @param dangerTpl - The template reference for the danger message to display.
   */
  showDanger(dangerActionTpl: any) {
    this.toastService.clear();
    this.toastService.show(dangerActionTpl, {
      classname: 'bg-danger text-light',
      delay: 6000,
    });
  }

  /**
   * verifyTokenValidity() - Method to check the email token
   * @param token generated token
   */
  verifyTokenValidity(token: any, formId: number): void {
    this.userFormService.authenticateEmailToken(token)
      .pipe()
      .subscribe({
        next: (response: any) => {
          this.requestResponse = response?.message;
          this.cogFormId = formId;
          this.formData = response?.responseDTO;
          this.isTokenValid = true;
          this.loading = false;
          this.overlayState = false;
        },
        error: (error) => {
          this.requestResponse = typeof error === 'string' ? error : COGNITO_MESSAGES.SOMETHING_WRONG;
          this.loading = false;
          this.overlayState = false;
          this.showDanger(this.dangerTpl);
          this.showMessage(error, false);
          console.error(error);
        }
      });
  }
}
